(function () {
  var SELECTOR_LIST  = '#header-component .header-menu .menu-list__list';
  var SELECTOR_ITEMS = '.menu-list__list-item';
  var CURSOR_CLASS   = 'vn-pill-cursor';

  function init() {
    var list = document.querySelector(SELECTOR_LIST);
    if (!list || list.dataset.vnInit) return;
    list.dataset.vnInit = '1';

    var cursor = document.createElement('li');
    cursor.className = CURSOR_CLASS;
    cursor.setAttribute('aria-hidden', 'true');
    list.appendChild(cursor);

    var items = list.querySelectorAll(':scope > ' + SELECTOR_ITEMS);

    function moveTo(item) {
      var lr = list.getBoundingClientRect();
      var ir = item.getBoundingClientRect();
      cursor.style.left    = (ir.left - lr.left) + 'px';
      cursor.style.width   = ir.width + 'px';
      cursor.style.opacity = '1';
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { moveTo(item); });
    });

    list.addEventListener('mouseleave', function () {
      cursor.style.opacity = '0';
    });

    list.querySelectorAll('.menu-list__link').forEach(function (link) {
      link.addEventListener('focus', function () { moveTo(link.closest(SELECTOR_ITEMS)); });
      link.addEventListener('blur',  function () { cursor.style.opacity = '0'; });
    });
  }

  // Mega-menu column filter. Delegated from the document so it survives the
  // Section Rendering API swapping the submenu in after first paint, which is
  // why this is not bound per input at init time.
  function filterColumn(input) {
    var list = document.querySelector('[data-vhm-list="' + input.dataset.vhmFilter + '"]');
    if (!list) return;

    var term = input.value.trim().toLowerCase();
    var shown = 0;

    list.querySelectorAll('.vhm__row[data-vhm-name]').forEach(function (row) {
      var hit = !term || row.dataset.vhmName.indexOf(term) !== -1;
      row.hidden = !hit;
      if (hit) shown++;
    });

    var empty = list.querySelector('.vhm__row--empty');
    if (empty) empty.hidden = shown !== 0;
  }

  document.addEventListener('input', function (event) {
    var input = event.target.closest ? event.target.closest('[data-vhm-filter]') : null;
    if (input) filterColumn(input);
  });

  // Escape clears the box instead of closing the whole menu behind it.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var input = event.target.closest ? event.target.closest('[data-vhm-filter]') : null;
    if (!input || !input.value) return;
    event.stopPropagation();
    input.value = '';
    filterColumn(input);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    var list = document.querySelector(SELECTOR_LIST);
    if (list) delete list.dataset.vnInit;
    init();
  });
})();

/* ---------------------------------------------------------------------------
   Mega-menu spotlight auto-advance.

   Cross-fades the tall spotlight tile when its menu group holds more than one
   link. Only runs while the panel is actually open (an IntersectionObserver on
   the tile), and pauses on hover/focus so the target never moves under the
   pointer mid-click. Honours prefers-reduced-motion by not running at all.
--------------------------------------------------------------------------- */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initSpotlight(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.vhm__spot-slide'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('.vhm__spot-dot'));
    var caption = root.querySelector('[data-vhm-spot-caption]');
    var delay = parseInt(root.getAttribute('data-vhm-interval'), 10) || 4500;
    var index = 0;
    var timer = null;
    var paused = false;

    function show(next) {
      slides.forEach(function (s, i) {
        if (i === next) {
          s.setAttribute('data-active', '');
          s.removeAttribute('aria-hidden');
          s.removeAttribute('tabindex');
        } else {
          s.removeAttribute('data-active');
          s.setAttribute('aria-hidden', 'true');
          s.setAttribute('tabindex', '-1');
        }
      });
      dots.forEach(function (d, i) {
        if (i === next) d.setAttribute('data-active', '');
        else d.removeAttribute('data-active');
      });
      if (caption) {
        var label = slides[next].getAttribute('data-caption');
        if (label) caption.textContent = label;
      }
      index = next;
    }

    function tick() {
      if (paused) return;
      show((index + 1) % slides.length);
    }

    function start() {
      if (timer || reduce.matches) return;
      timer = setInterval(tick, delay);
    }

    function stop() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }

    root.addEventListener('pointerenter', function () { paused = true; });
    root.addEventListener('pointerleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    // Only cycle while the panel is on screen; a closed submenu has zero size.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.1 }).observe(root);
    } else {
      start();
    }
  }

  function init() {
    document.querySelectorAll('[data-vhm-spot]').forEach(initSpotlight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------------------------------------------------------------------------
   Shop by Device rail.

   Swaps which brand pane is visible as the pointer moves down the rail. The
   first tab is already marked active in Liquid, so the panel is correct with JS
   off and before this runs; this only adds the switching.

   Delegated from the document for the same reason the column filter above is:
   the Section Rendering API can swap the submenu in after first paint, so
   per-element listeners bound at init would be lost.
--------------------------------------------------------------------------- */
(function () {
  function activate(tab) {
    var root = tab.closest('[data-device-menu]');
    if (!root || tab.hasAttribute('data-active')) return;

    var paneId = tab.getAttribute('data-device-tab');

    root.querySelectorAll('[data-device-tab]').forEach(function (t) {
      if (t === tab) t.setAttribute('data-active', '');
      else t.removeAttribute('data-active');
    });

    root.querySelectorAll('[data-device-pane]').forEach(function (p) {
      p.hidden = p.getAttribute('data-device-pane') !== paneId;
    });
  }

  // pointerover, not pointerenter: pointerenter does not bubble, so it cannot be
  // delegated from the document.
  document.addEventListener('pointerover', function (event) {
    var tab = event.target.closest ? event.target.closest('[data-device-tab]') : null;
    if (tab) activate(tab);
  });

  // Keyboard parity: tabbing through the rail reveals each pane in turn.
  document.addEventListener('focusin', function (event) {
    var tab = event.target.closest ? event.target.closest('[data-device-tab]') : null;
    if (tab) activate(tab);
  });
})();
